import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ErrorResponseWithIdI } from 'src/app/core/models/error-response-with-id.interface';
import { TypesService } from 'src/app/core/services/api/types/types.service';
import { DictionaryI } from 'src/app/dictionaries/models/dictionary.interface';
import {
  CleanEventTypesState,
  EventTypesActionTypes,
  LoadedEventTypesFail,
  LoadedEventTypesSuccess,
} from 'src/app/dictionaries/store/actions/event-types.action';

@Injectable()
export class EventTypesEffects {
  constructor(private actions$: Actions, private typesService: TypesService) {}

  public loadEventTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EventTypesActionTypes.LoadEventTypes),
      switchMap(() =>
        this.typesService.getEventTypes().pipe(
          map(
            (eventTypes: DictionaryI[]) =>
              new LoadedEventTypesSuccess(eventTypes)
          ),
          catchError((error: ErrorResponseWithIdI) =>
            of(new LoadedEventTypesFail(error))
          )
        )
      )
    )
  );

  public handleLoadedEventTypesFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EventTypesActionTypes.LoadedEventTypesFail),
      map(() => new CleanEventTypesState())
    )
  );
}
